import {Component, Fragment, h} from "preact";
import {Link} from "react-router-dom";

type Props = {
    status: string
}

class Tabs extends Component<Props, any> {

    render = ({status}:Props) =>
    <div className="tabs-container">
        <div className="inline">
            <Link to="/offers" className={status === 'active'?'selected':''}>Activas</Link>
        </div>
        <div className="inline">
            <Link to="/archived" className={status === 'archived'?'selected':''}>Archivadas</Link>
        </div>
        <div className="inline">
            <Link to="/drafts" className={status === 'drafts'?'selected':''}>Borradores</Link>
        </div>
    </div>;
}

export default Tabs;
